import {
  Button,
  Flex,
  Grid,
  SelectField,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";

const FAKE_EQUIPMENTS = [
  { id: "eq-001", name: "Pulverizador 200L" },
  { id: "eq-002", name: "Tractor AG-50" },
  { id: "eq-003", name: "Bomba de riego BX-10" },
  { id: "eq-004", name: "Soplador SB-3" },
  { id: "eq-005", name: "Desmalezadora DM-12" },
];

const FAKE_SERIALS_BY_EQUIPMENT = {
  "eq-001": [
    "SN-P200-001",
    "SN-P200-002",
    "SN-P200-003",
    "SN-P200-004",
    "SN-P200-005",
  ],
  "eq-002": [
    "SN-T50-101",
    "SN-T50-102",
    "SN-T50-103",
    "SN-T50-104",
    "SN-T50-105",
  ],
  "eq-003": [
    "SN-BX10-201",
    "SN-BX10-202",
    "SN-BX10-203",
    "SN-BX10-204",
    "SN-BX10-205",
  ],
  "eq-004": [
    "SN-SB3-301",
    "SN-SB3-302",
    "SN-SB3-303",
    "SN-SB3-304",
    "SN-SB3-305",
  ],
  "eq-005": [
    "SN-DM12-401",
    "SN-DM12-402",
    "SN-DM12-403",
    "SN-DM12-404",
    "SN-DM12-405",
  ],
};

const FAKE_COLLABORATORS = [
  { id: "col-0001", name: "Juan Pérez" },
  { id: "col-0002", name: "María Gómez" },
  { id: "col-0003", name: "Carlos Rojas" },
  { id: "col-0004", name: "Ana Martínez" },
  { id: "col-0005", name: "Luis Díaz" },
];

const EquipmentMaintenanceForm = ({
  onSubmit,
  type = "create",
  initialValues = {},
  onCancel,
}) => {
  const defaultState = {
    date: "",
    equipmentId: "",
    equipmentName: "",
    serialNumber: "",
    protocolDescription: "",
    performedById: "",
    performedByName: "",
    photoEvidence: "",
    observations: "",
    createdAt: "",
  };

  const [form, setForm] = useState({ ...defaultState, ...initialValues });
  const [availableSerials, setAvailableSerials] = useState([]);

  useEffect(() => {
    setForm({ ...defaultState, ...initialValues });

    if (initialValues.equipmentId) {
      const serials =
        FAKE_SERIALS_BY_EQUIPMENT[initialValues.equipmentId] || [];
      setAvailableSerials(serials);
      const eq = FAKE_EQUIPMENTS.find(
        (e) => e.id === initialValues.equipmentId
      );
      if (eq && !initialValues.equipmentName)
        setForm((f) => ({ ...f, equipmentName: eq.name }));
    }

    if (initialValues.performedById && !initialValues.performedByName) {
      const found = FAKE_COLLABORATORS.find(
        (c) => c.id === initialValues.performedById
      );
      if (found) setForm((f) => ({ ...f, performedByName: found.name }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  const handleEquipmentChange = (equipmentId) => {
    const eq = FAKE_EQUIPMENTS.find((e) => e.id === equipmentId);
    const serials = FAKE_SERIALS_BY_EQUIPMENT[equipmentId] || [];
    setAvailableSerials(serials);
    setForm({
      ...form,
      equipmentId,
      equipmentName: eq ? eq.name : "",
      serialNumber: "",
    });
  };

  const onSubmitForm = () => {
    const payload = { ...form };
    if (!payload.createdAt) payload.createdAt = new Date().toISOString();
    onSubmit && onSubmit(payload);
  };

  return (
    <Grid rowGap="12px" columnGap="12px" padding="20px">
      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <TextField
          name="date"
          label={strings.fields.date.label}
          placeholder="YYYY-MM-DD"
          value={form.date || ""}
          onChange={(e) => setForm({ ...form, date: e.target.value })}
        />

        <SelectField
          name="equipmentId"
          label={strings.fields.equipmentId.label}
          value={form.equipmentId || ""}
          onChange={(e) => handleEquipmentChange(e.target.value)}
        >
          <option value="">--</option>
          {FAKE_EQUIPMENTS.map((eq) => (
            <option key={eq.id} value={eq.id}>
              {eq.name}
            </option>
          ))}
        </SelectField>
      </Grid>

      <Grid gap="12px" templateColumns={{ base: "1fr", large: "1fr 1fr" }}>
        <SelectField
          name="serialNumber"
          label={strings.fields.serialNumber.label}
          value={form.serialNumber || ""}
          onChange={(e) => setForm({ ...form, serialNumber: e.target.value })}
        >
          <option value="">--</option>
          {availableSerials.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </SelectField>

        <SelectField
          name="performedById"
          label={strings.fields.performedById.label}
          value={form.performedById || ""}
          onChange={(e) => {
            const val = e.target.value;
            const found = FAKE_COLLABORATORS.find((c) => c.id === val);
            setForm({
              ...form,
              performedById: val,
              performedByName: found ? found.name : "",
            });
          }}
        >
          <option value="">--</option>
          {FAKE_COLLABORATORS.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </SelectField>
      </Grid>

      <TextAreaField
        name="protocolDescription"
        label={strings.fields.protocolDescription.label}
        value={form.protocolDescription || ""}
        onChange={(e) =>
          setForm({ ...form, protocolDescription: e.target.value })
        }
      />

      <TextAreaField
        name="observations"
        label={strings.fields.observations.label}
        value={form.observations || ""}
        onChange={(e) => setForm({ ...form, observations: e.target.value })}
      />

      <TextField
        name="photoEvidence"
        label={strings.fields.photoEvidence.label}
        placeholder="foto1.jpg, foto2.jpg"
        value={
          Array.isArray(form.photoEvidence)
            ? form.photoEvidence.join(", ")
            : form.photoEvidence || ""
        }
        onChange={(e) => setForm({ ...form, photoEvidence: e.target.value })}
      />

      <Flex justifyContent="end">
        <Button
          children={strings.fields.buttons.reset}
          onClick={() => setForm(defaultState)}
        />
        <Button
          children={
            type === "create"
              ? strings.fields.buttons.create
              : strings.fields.buttons.save
          }
          onClick={onSubmitForm}
          variation="primary"
        />
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    fields: {
      date: { label: "Fecha" },
      equipmentId: { label: "Equipo" },
      serialNumber: { label: "Serial" },
      protocolDescription: { label: "Descripción del protocolo" },
      performedById: { label: "Persona que realiza" },
      photoEvidence: { label: "Evidencia fotográfica" },
      observations: { label: "Observaciones" },
      createdAt: { label: "Fecha de creación" },
      buttons: {
        create: "Crear",
        save: "Guardar",
        reset: "Restablecer",
        cancel: "Cancelar",
      },
    },
  },
});

export default EquipmentMaintenanceForm;
